// Thx to https://stackoverflow.com/questions/14866775/detect-document-height-change
function onElementHeightChange(elm, callbacks) {
  var lastHeight = elm.clientHeight, newHeight;

  function run() {
    newHeight = elm.clientHeight;
    if (lastHeight !== newHeight) {
      callbacks.forEach(cb => cb());
    }
    lastHeight = newHeight;
  };

  return setInterval(run, 50);
}

const listenedElements = [];

function addListener(element, cb) {
  const node = listenedElements.find((listenerInfo => listenerInfo.element === element));
  // Trying to reuse already existed listeners
  if (node) {
    node.callbacks.push(cb);
  } else {
    const listenerIndex = listenedElements.push({ element, callbacks: [cb] }) - 1;
    listenedElements[listenerIndex].intervadId = onElementHeightChange(element, listenedElements[listenerIndex].callbacks);
  }
}

function removeListener(element, cb) {
  const listenerIndex = listenedElements.findIndex((listenerInfo => listenerInfo.element === element));
  if (listenerIndex > -1) {
    const listener = listenedElements[listenerIndex];
    const callbackIndex = listener.callbacks.findIndex(callback => callback === cb);
    if (callbackIndex > -1) {
      listener.callbacks.splice(callbackIndex, 1);
      if (listener.callbacks.length === 0) {
        clearInterval(listener.intervadId);
        listenedElements.splice(listenerIndex, 1);
      }
    }
  }
}

module.exports = {
  addListener,
  removeListener,
}


// WEBPACK FOOTER //
// ./src/utils/resize-listener.js